import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import UserTestimonyCard from '../../components/cards/UserTestimonyCard';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

function WistiaPopup() {
	const [modalShow, setModalShow] = React.useState(false);
	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://youtu.be/R4X03e-66yI'
							playing
							volume={1}
							controls={true}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const Home = (props) => {


	const location = props.location;

	return (
		<Layout  bodyClass="why-charthop" ontouchstart>
			<SEO title="Why ChartHop | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta name="description" content="Your most strategic work happens in manual spreadsheets. It's time to upgrade." />
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Why ChartHop | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="Your most strategic work happens in manual spreadsheets. It's time to upgrade." />
				<meta property="og:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Why ChartHop | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="Your most strategic work happens in manual spreadsheets. It's time to upgrade." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/visualized.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

			{/* HERO CONTENT */}
			<section className="intro sectionSpacing">
                <div className="row contentBlock pt-4 pb-1 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Why ChartHop?</h1>
                        <p className="header-p pb-1 pt-1">Because we  <i>get</i>  people data.</p>
                        <div className="splitText"><DemoFormShort source={"platform-why-charthop-demo-header"} /></div>  
						<WistiaPopup />                       
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one">                        
                        <img className="imageBoxShaddow fullSegmentImage mx-auto" src={'/product/2105-refresh/reports.png'} alt="Performance Review Org Chart" />
					</div>
                </div>
            </section>

			{/* TECHNOLOGY */}			
			<section className="technology sectionSpacing backgroundGradientContainer pt-7 pb-2">
				<div className="container">

					{/* HR SOLUTIONS */}
					<div name="data" id="data" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="right"
							title="Your people data is your most important data."
							link="/product/people-analytics/Integration_reports-2.mp4"
							type="video"
							paddingClass="padding-top-video-three"
							content={
								<React.Fragment>
									<p>And ChartHop was purpose-built for it. </p>

									<p>ChartHop brings together all your people data - from payroll & demographic to performance & engagement. We handle it with extreme care, ensuring the most sensitive data is protected.</p>
										
									<p>Centralize your data & processes, and eliminate additional spend and overhead.</p>
									<a href={PATHS.INTEGRATIONS} className="ctaStandard smallMobile">Learn more about our integrations</a>
								</React.Fragment>
							}
						/>
					</div>

					{/* PLANNING */}
					<div name="access" id="access" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="left"
							title="Data is only as useful as it is accessible."
							link="/product/2105-refresh/side-profile.png"
							type="image"
							paddingClass="padding-top-video-two"
							content={
								<React.Fragment>
									<p>That's why ChartHop is easy to use by anyone in the organization - not just your analysts.</p>
									<p>	Through powerful yet simple visualizations, ChartHop empowers all levels of your organization to make the right people decisions - in real time.
									</p>
									<a href={PATHS.REPORTING} className="ctaStandard smallMobile">See reporting in action</a>
									<br></br>
									<a href={PATHS.INTEGRATIONS} className="ctaStandard smallMobile">Check out the best org chart in the market</a>
								</React.Fragment>
							}
						/>
					</div>

					{/* DIVERSITY */}
					<div name="action" id="action" className="contentBlock pb-lg-1 pb-7">
						<MultimedialPanel 
							multimediaPosition="right"
							title="You need to translate insights into action, quickly."
							link="/product/2105-refresh/data-sheet-performance.png"
							type="image"
							paddingClass="padding-top-video-three"
							content={
								<React.Fragment>
									<p>Stop wasting time wrangling spreadsheets together. </p>
									<p>	Power headcount plans, compensation adjustments, DEI strategies and employee engagement initiatives with the data needed to make the best decisions. </p>
									<p> With ChartHop, data is just the beginning. 
									</p>
									<a href={PATHS.PLANNING} className="ctaStandard smallMobile">Make better, data-informed decisions</a>
								</React.Fragment>
							}
						/>
					</div>
					
				</div>				
			</section>
			
            {/* EVERYTHING */}
            <section className="everything sectionSpacing flex-centeredColumn padding-section pt-7 pb-6">
            	<h2 className="text-center mt-0 sectionSpacing-Margin ">Everything you need in one platform</h2> 
            	<div className="flex-centeredColumn contentBlock">
					<div className="flex-platform svg-info-card-everything">
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/data-centralization.svg '} alt="Visualize" />
							<p className="">Data Centralization</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/visualize.svg'} alt="Put a face to the name" />
							<p className="">Org Chart & Employee Profiles</p>
						</div>
						<div className="svg-info-card-3col2 ">
							<img src={'/product/org-chart/people-analytics.svg'} alt="Time Saving" />
							<p className="">Robust Reporting</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/compensation.svg'} alt="Transparency" />
							<p className="">Compensation & Headcount Planning</p>
						</div>
						<div className="svg-info-card-3col2">
							<img src={'/product/org-chart/performance.svg'} alt="Work" />
							<p className="">Performance Reviews</p>
						</div>          
					</div>
				</div>
            </section>

			{/* COSTUMER */}
			<section className="customer backgroundGradientContainer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >

			{/* TESTIMONIAL */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse pt-0 pb-8" id="Customer Stories">            
				<div className="contentBlock row">
					<div className="col-12"> 
						<UserTestimonyCard
							testimony={<p>
								“ChartHop is the perfect product in a world where <strong>remote</strong> work is the standard, where building <strong>diverse</strong> teams is critical and being <strong>agile</strong> as a business is the only way to <strong>thrive</strong>.”
								</p>}
							logo="/home/brand_logos/bettercloud-logo.svg"
							name="David Politis"
							readMoreButton={false}
							readMoreLink=""
							readMoreText="case studies"
							position="CEO @ BetterCloud"
							image="/home/quotes/DavidPolitis_BetterCloud.jpeg"
						/> 
					</div>
				</div> 
            </section>		

			{/* BUILT */}
			<section className="built backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn pt-7">
            	<h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2> 
            	<h4 className="text-center mt-0 sectionSpacing-Margin">Seamless integrations means you can get up and running in as little as 30 minutes.</h4>
            	<div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>
                        {/* SECOND 4 */} 
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
								<img src='/integrations/logos/gusto.png' alt="Gusto" /> 	
                            </div>
                        </div>
						<div>
                            <div>
                                <img src='/integrations/logos/logo-google.jpg' alt="Google" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>
                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>  
                        {/* PSEUDO */}
                        <div className="psudeo ps1">
                        </div>
                        <div className="psudeo ps2">
                        </div>
                        <div className="psudeo ps3">
                        </div>
                        <div className="psudeo ps4">
                        </div>                        
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>

			{/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-7 pb-md-8">
				<DemoFormLong source={"platform-why-charthop-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class="mb-1 contact-testimonial">"ChartHop helped us replace our mundane, outdated processes - there is nothing else like it.</p> <p class="contact-testimonial"> I can not imagine what we would do without ChartHop.”</p><div class="authorTag"><img src="/home/quotes/quote_DavidDankenbrink@2x.jpg" class="testimonialAuthor" alt="David Dankenbrink" /><div><p class="contactAuthor"><strong>David Dankenbrink</strong> <br>Vice President, Human Resources @ Remy Cointreau</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Home;
